import { render, staticRenderFns } from "./modal-palestrantes-sala.vue?vue&type=template&id=97512ef4&"
import script from "./modal-palestrantes-sala.vue?vue&type=script&lang=js&"
export * from "./modal-palestrantes-sala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports